import { Box, Typography } from "@mui/material";
import { textXS } from "../../../../shared/constants";
import { useWiserTheme } from "../../../../hooks/useWiserTheme";
import { getInterviewStatusTagColors } from "../../../../shared/theme/wiserThemeHelpers";
import { getTagChipSx } from "../../style";

const formatDate = (date: string | null) => {
  if (!date) return "";
  return new Date(date)
    .toLocaleString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(",", "");
};

export const InterviewStatusTag = ({
  status,
  interviewDate,
}: {
  status: string;
  interviewDate: string;
}) => {
  const { darkModeActive } = useWiserTheme();
  const statusColors = getInterviewStatusTagColors(status, darkModeActive);
  const formattedDate = formatDate(interviewDate);
  return (
    <Box sx={getTagChipSx(statusColors.bg)}>
      <Typography sx={textXS(500, statusColors.text)}>
        {status.toTitleCaseTR()} - {formattedDate}
      </Typography>
    </Box>
  );
};
